import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"runnit-field-header"},[(_vm._get(_vm.field, 'icon'))?_c(VIcon,{staticStyle:{"font-size":"22px","color":"white","margin":"0 7px 0 5px"}},[_vm._v(" "+_vm._s(_vm.field.icon)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.field.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }